import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const NotFoundPage = () => (
  <Layout>
    <SEO title="404: Not found" />
    <h1>404: Not Found</h1>
    <p>잘못된 경로로 접근하였습니다.</p>
  </Layout>
)

export default NotFoundPage
